<style scoped>
.header {
  min-width: 1200px;
  width: 100%;
  height: 70px;
  background: #313541;
}

.header-cont {
  width: auto;
  margin: 0 0 0 30px;
}

.header-cont > .logo {
  float: left;
  width: 36px;
  margin: 15px 0;
}
.header-cont > .logoTitle {
  float: left;
  padding-left: 15px;
  font-size: 22px;
  color: white;
  padding-top: 15px;
}
.header-cont > .logo img {
  width: 100%;
}
.tag {
  float: left;
  padding-top: 20px;
  padding-left: 15px;
}
.header-cont .el-tag {
  background-color: #2ECFA7;
  padding: 0 10px;
  height: 30px;
  line-height: 28px;
  font-size: 12px;
  color: #2ECFA7;
  border-radius: 0px 18px 18px 18px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #2ECFA7;
  white-space: nowrap;
}
.area {
  color: white;
  font-size: 18px;
  font-weight: bold;
}
.storeName {
  color: #fff;
  font-size: 14px;
  /* font-weight: bold; */
}
.header-cont .right-nav {
  width: 30%;
  float: right;
  /* margin-left: 118px; */
  border-left: 1px solid #434756;
}

.header-cont .right-nav li {
  height: 70px;
  width: 33.3%;
  float: left;
  margin: auto 0;
  line-height: 60px;
  padding: 0 !important;
  background: url(../../assets/images/store/left.png) no-repeat left center;
}
.header-cont .right-nav li:first-child{
  background: none;
}

.header-cont .right-nav li > a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: #fff !important;
  font-weight: bold;
  text-align: center;
}
.header-cont .right-nav li > a::after{
  transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
}

.header-cont .right-nav li:hover {
  background: none;
}
.header-cont .right-nav li > a:hover {
  /* color: #4389f5 !important; */
  font-weight: bold;
  background: #3b404f;
}
.header-cont .right-nav li > a:hover::after {
  content: '';
  position: absolute;
  bottom: 6px;
  width: 80%;
  left: 10%;
  height: 5px;
  background: #f83b56;
  border-radius:2px;
}
.header-cont .right-nav li > a.active{
  background: #3b404f;
}
.header-cont .right-nav li > a.active::after {
  content: '';
  position: absolute;
  bottom: 6px;
  width: 80%;
  left: 10%;
  height: 5px;
  background: #f83b56;
  border-radius:2px;
}
.router-link-active {
  color: #fff !important;
  font-weight: bold;
  background: #3b404f;
  position: relative;
}
.router-link-active::after{
  content: '';
  position: absolute;
  bottom: 6px;
  width: 80%;
  left: 10%;
  height: 5px;
  background: #f83b56;
  border-radius:2px;
}
.header-cont .right-nav .nav-active {
  color: #fff;
  font-weight: bold;
}

.header-info {
  float: left;
  cursor: pointer;
  position: relative;
  height: 40px;
  margin: 15px 0;
  box-sizing: border-box;
  padding:6px 10px 6px 20px;
}
.header-info > .current {
  color: #a6abbc;
  float: left;
}
.header-info > .header-img {
  width: 16px;
  height: 18px;
  overflow: hidden;
  float: left;
}

.header-info > .header-img > img {
  width: 100%;
}

.username {
  float: left;
  /* line-height: 32px; */
  margin: auto 10px;
  margin-top: -4px;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.header-info > i {
  margin: 4px 0;
  float: left;
}
.setStyle {
  float: right;
  background-color: white;
  height: 66px;
}
.header .el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
  margin: 20px 15px;
}
/* 下拉隐藏 */
.myHeaderTab .changebtns {
  width: 55px;
  height: 47px;
  cursor: pointer;
  position: absolute;
  /* bottom: -42px; */
  right: 110px;
  top: 65px;
  background: url(../../assets/images/store/btn_topmenu_packup.png) no-repeat center;
  background-size: contain
}

.myHeaderTab .changebtns.downer {
  top: -2px;
  background: url(../../assets/images/store/btn_topmenu_expand.png) no-repeat center;
  background-size: contain
}
.myHeaderTab.el-menu--collapse{
  width: 100%;
}
.myHeaderTab.el-menu--collapse .header{
  min-width: 100%;
  width: 100%;
  height: 4px;
  overflow: hidden;
}
.myHeaderTab.el-menu--collapse .setStyle{
  background: none;
}

</style>
<template>
  <el-menu class="myHeaderTab">
      <div class="header">
          <div class="header-cont">
              <!-- <span class="logo">
                  <img src="../../assets/images/store/logo_tingmei.png" v-if="$store.state.userInfo.brandId == 1">
                  <img src="../../assets/images/store/logo_zhenyoutang.png" v-else-if="$store.state.userInfo.brandId == 2">
                  <img src="../../assets/images/shopping/meiboshi.png" v-else>
              </span>
              <span class="logoTitle">{{$store.state.userInfo.brandId == 1 ? '婷美摩力21产后恢复' : ($store.state.userInfo.brandId == 2 ? '臻幼堂' : '槑博士婴幼儿草本浴')}}</span> -->
              <div style="float: right;height: 70px;background: #3b404f;">
                <div class="header-info">
                  <span class="username" @click="toLogin" v-loading.fullscreen.lock="fullscreenLoading">返回登录</span>
                </div>
            </div>
          </div>
      </div>
  </el-menu>
</template>
<script>
import {outStore, toLoginOut} from '@/api'
export default {
  data() {
    return {
      fullscreenLoading: false,
      tabFlag: false,
      isHeaderCollapse: false,
      basicCenter:false,
      businessCenter:false,
      operaCenter:false,
    };
  },
  methods: {
    toLogin() {
      this.fullscreenLoading = true;
      this.delCookie("session");
      //演示
      toLoginOut().then(res=>{
        setTimeout(() => {
          this.fullscreenLoading = false;
          this.$router.push("/login/");
        },500)
      })
    },
  }
};
</script>





// WEBPACK FOOTER //
// src/components/common/HeaderForget.vue